module.exports = __webpack_public_path__ + "img/Flag_of_Mongolia.de74763a.svg";